import * as Yup from 'yup';

import { phoneRegex } from '@lamesarv-sdk/tools';

import { IFormMetadataProps, IFormProps } from '../types';

export const validationSchema = Yup.object().shape(
  {
    firstName: Yup.string().required('First Name is required'),
    lastName: Yup.string().required('Last Name is required'),
    email: Yup.string().email().required('Email is required'),
    location: Yup.string().required('Store location is required'),
    phone: Yup.string()
      .notRequired()
      .when('phone', {
        is: (value: string) => value?.length,
        then: (rule) => rule.matches(phoneRegex, 'Please enter a valid phone number.'),
      }),
    mobile: Yup.string()
      .notRequired()
      .when('mobile', {
        is: (value: string) => value?.length,

        then: (rule) => rule.matches(phoneRegex, 'Please enter a valid phone number.'),
      }),
  },
  [
    ['phone', 'phone'],
    ['mobile', 'mobile'],
  ],
);

export interface IFormSchema extends IFormProps, IFormMetadataProps {
  firstName: string;
  lastName: string;
  phone: string;
  mobile: string;
  email: string;
  location: string;
  comments: string;
  emailType: string;
  stockNumber: string;
}
